import { useSelector } from 'react-redux';
import { Row, Col, Card } from 'antd';
import { selectors } from '@/redux/tour/trip/view/model';
import PhotoGallery from '@/components/PhotoGallery';
import ViewWidgetCategories from '@/components/ViewWidgetCategories';
import GeneralData from './GeneralData';
import Extras from './Extras';
import ViewIncusionsExclusions from './ViewInclusionsExclusions';

const TourInfo = ({ myService }) => {
    const generalInfo = useSelector(selectors.generalInfo);

    return (
        <Row gutter={30}>
            <Col lg={14} xs={24}>
                <Card bordered={false} className="left-col">
                    <GeneralData
                        data={generalInfo}
                        myService={myService}
                    />

                    <Extras />

                    <ViewWidgetCategories data={generalInfo.widget_categories} />

                    <ViewIncusionsExclusions data={generalInfo} />
                </Card>
            </Col>

            <Col lg={10} xs={24}>
                <Card bordered={false} className="right-col">
                    <PhotoGallery data={generalInfo.images} />
                </Card>
            </Col>
        </Row>
    );
};

export default TourInfo;
